import React from 'react'
import { Link } from 'react-router-dom';
import { BackArrowIcon2, Back_img, Settings, scrollx_icon } from '../assets/icons';
import "./Navbar.css";



export default function Navbar_back_btn({ path }) {
  return (
    <div className='w-[100%] h-[64px] Pro_navbar flex items-center justify-between drop-shadow-2xl px-[5%]'>
      <div className=''>
        <Link to={path ? path : "../home"}>
          <img className='pl-[14px]  w-[49px] cursor-pointer' src={BackArrowIcon2}  />
        </Link>
      </div>
      <div className=' w-[100px] scrollxLogo'>
        {/* <img src={scrollx_icon} style={{ width: "50px" }} /> */}
        <div className="Syne  text-base font-extrabold tracking-wide text-white">SCROLLX.io</div>

      </div>
      <div className=' mr-0 w-[80px] '>
        {/* <img src={Settings}  style={{width:"30px"}} /> */}
      </div>
    </div>
  )
}
